module.exports = __webpack_public_path__ + "img/19.625ede26.png";